import { AxiosResponse } from 'axios';

import { useSuspenseQuery } from '@tanstack/react-query';
import type { TypeGetLaborAccountsMeResponse } from '~/api/laborAccounts';
import { registerMockAPI } from '~/mocks/mockApis';

import { axiosInstance } from '~/services/fetchServiceV2';

/** @desciption 회원 개인 정보를 조회하는 커스텀 훅 */
export const useGetMemberPrivacyInfo = () => {
  return useSuspenseQuery({
    queryKey: ['labor-accounts', 'me'],
    queryFn: () => axiosInstance.get<TypeGetLaborAccountsMeResponse>('/labor-accounts/me'),
    gcTime: 0,
    retry: 1,
    select: (response: AxiosResponse<TypeGetLaborAccountsMeResponse>) => response.data,
  });
};

registerMockAPI<TypeGetLaborAccountsMeResponse>({
  method: 'get',
  endpoint: '/labor-accounts/me',
  label: '근무 지원 정보/회원 정보 조회',
  scenarios: [
    {
      name: '인증 이력 있음',
      response: {
        code: '0000',
        message: '성공',
        data: {
          name: '홍길동',
          phoneNumber: '01012345678',
          prefillAvailable: true,
          birthDate: '900115',
          genderDigit: '1',
        },
      },
    },
    {
      name: '인증 이력 없음 (생년월일/성별 미입력)',
      response: {
        code: '0000',
        message: '성공',
        data: {
          name: '홍길동',
          phoneNumber: '01012345678',
          prefillAvailable: false,
          birthDate: null,
          genderDigit: null,
        },
      },
    },
    {
      name: '인증 이력 없음 (생년월일/성별 입력)',
      response: {
        code: '0000',
        message: '성공',
        data: {
          name: '홍길동',
          phoneNumber: '01012345678',
          prefillAvailable: false,
          birthDate: '900115',
          genderDigit: '1',
        },
      },
    },
  ],
});
